<template>
  <div class="main">
    <div class="introduction">
      <div class="content">
        <div class="content-banner">
          <img src="@/assets/img/qiji-banner.png" alt="奇绩创坛校友中心">
        </div>
        <div class="content-writing">
          <p class="text">2022年中关村创业大街携手奇绩创坛，共建“奇绩创坛校友中心”，链接校友企业，定位校友办公中心、校友交流中心、校友活动中心、校友服务中心。</p>
          <p class="link"><a href="https://www.miracleplus.com/" target="_blank">奇绩创坛<span class="right-triangle"></span></a></p>
          <p class="link"><a href="https://www.z-innoway.com/" target="_blank">中关村创业大街<span class="right-triangle"></span></a></p>
        </div>
      </div>
    </div>
    <div class="miracle">
      <div class="mir-service">
        <h2 class="title">奇绩创坛校友企业服务</h2>
        <div class="service-list">
          <div class="service-item">
            <h3>企业注册落地服务</h3>
            <p>为奇绩创坛校友提供两年免费虚拟注册地址并提供注册服务</p>
            <button @click="toLook(1)">查看</button>
          </div>
          <div class="service-item">
            <h3>免费过渡工位</h3>
            <p>为当期奇绩创业营项目提供3个月办公工位及公共资源的使用权利</p>
            <button @click="toLook(2)">查看</button>
          </div>
          <div class="service-item">
            <h3>企业管家式服务</h3>
            <p>为奇绩创坛校友提供包括人才服务、政策咨询与政府资源对接、宣传推广等一系列服务</p>
            <button @click="toLook(3)">查看</button>
          </div>
          <div class="service-item">
            <h3>校友活动场地</h3>
            <p>为奇绩创坛校友会、奇绩创坛校友提供活动场地支持</p>
            <button @click="toLook(4)">查看</button>
          </div>
        </div>
      </div>
      <div class="mir-partner">
        <h2 class="title">奇绩创坛校友企业名单（部分）</h2>
        <div class="header-list">
          <div>生物领域</div>
          <div>企业服务</div>
          <div>ESG</div>
          <div>芯片</div>
          <div>机器人</div>
          <div>开源</div>
          <div>智能制造</div>
        </div>
        <div class="first-part" :class="boxshow?'first-part-open':'first-part-close'">
          <div class="partner-list">
            <div><img src="@/assets/img/大橡科技.png" alt="大橡科技"></div>
            <div><img src="@/assets/img/ZEALCOMM.png" alt="ZEALCOMM"></div>
            <div><img src="@/assets/img/博萃循环.png" alt="博萃循环"></div>
            <div><img src="@/assets/img/EXR TECH.png" alt="EXR TECH"></div>
            <div><img src="@/assets/img/松果体机器人.png" alt="松果体机器人"></div>
            <div><img src="@/assets/img/格物钛.png" alt="格物钛"></div>
            <div><img src="@/assets/img/升华三维.png" alt="升华三维"></div>
          </div>
          <div class="partner-list">
            <div><img src="@/assets/img/臻泰智能.png" alt="臻泰智能"></div>
            <div><img src="@/assets/img/爱莫科技.png" alt="爱莫科技"></div>
            <div><img src="@/assets/img/美乐象象.png" alt="美乐象象"></div>
            <div><img src="@/assets/img/深谷光科技.png" alt="深谷光科技"></div>
            <div><img src="@/assets/img/忆海原识.png" alt="忆海原识"></div>
            <div><img src="@/assets/img/投光.png" alt="投光"></div>
            <div><img src="@/assets/img/多翼创新.png" alt="多翼创新"></div>
          </div>
          <div class="partner-list">
            <div><img src="@/assets/img/倍生生物.png" alt="倍生生物"></div>
            <div><img src="@/assets/img/云听.png" alt="云听"></div>
            <div><img src="@/assets/img/CAIDIO.png" alt="CAIDIO"></div>
            <div><img src="@/assets/img/位图.png" alt="位图"></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="partner-list">
            <div><img src="@/assets/img/杭州密码子.png" alt="杭州密码子"></div>
            <div><img src="@/assets/img/掌上科技.png" alt="掌上科技"></div>
            <div><img src="@/assets/img/碳中宝.png" alt="碳中宝"></div>
            <div><img src="@/assets/img/大禹.png" alt="大禹"></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="partner-list">
            <div><img src="@/assets/img/博志生物科技.png" alt="博志生物科技"></div>
            <div><img src="@/assets/img/拓疆者.png" alt="拓疆者"></div>
            <div><img src="@/assets/img/碳能科技.png" alt="碳能科技"></div>
            <div><img src="@/assets/img/原位芯片.png" alt="原位芯片"></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="partner-list">
            <div><img src="@/assets/img/小熊猫生物.png" alt="小熊猫生物"></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        
        <div class="header-list" style="margin-top:30px;">
          <div>商业航天</div>
          <div>云原生/开发者工具</div>
          <div>网络安全</div>
          <div>出海</div>
          <div>AR/VR</div>
          <div>生活服务</div>
          <div>智慧农业</div>
        </div>
        <div class="second-part" :class="boxshow?'second-part-open':'second-part-close'">
          <div class="partner-list">
            <div><img src="@/assets/img/星测未来1.png" alt="星测未来1"></div>
            <div><img src="@/assets/img/ZION.png" alt="ZION"></div>
            <div><img src="@/assets/img/火线.png" alt="火线"></div>
            <div><img src="@/assets/img/creditgo.png" alt="creditgo"></div>
            <div><img src="@/assets/img/exintoo.png" alt="exintoo"></div>
            <div><img src="@/assets/img/寻缘树.png" alt="寻缘树"></div>
            <div><img src="@/assets/img/小雨农智.png" alt="小雨农智"></div>
          </div>
          <div class="partner-list">
            <div><img src="@/assets/img/planetdata.png" alt="planetdata"></div>
            <div><img src="@/assets/img/authing.png" alt="authing"></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        
        <div class="open-btn"><button @click="boxshow = !boxshow">{{ !boxshow ? '展开' : '合并' }}</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"Home",
  data() {
    return {
      boxshow: false
    }
  },
  methods: {
    toLook(i) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      switch (i) {
        case 1:
          this.$router.push('/enterpriseRegister')
          break;
        case 2:
          this.$router.push('/station')
          break;
        case 3:
          this.$router.push('/housekeeper')
           break;
        case 4: 
          this.$router.push('/field')
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  .introduction {
    height: 438px;
    background: #F6F6F6;
    .content {
      display: flex;
      width: 1200px;
      height: 438px;
      margin: 0 auto;
      .content-banner {
        width: 500px;
        height: 300px;
        margin-top: 76px;
      }
      .content-writing {
        width: 600px;
        margin-top: 117px;
        margin-left: 54px;
        .text {
          color: #666666;
          padding-bottom: 20px;
        }
        .link {
          height: 20px;
          line-height: 20px;
          font-size: 20px;
          font-weight: 500;
          vertical-align: middle;
          margin-top: 25px;
          a {
            display: flex;
            align-items: center;
            color: #0079FF;
            text-decoration: none;
          }
          a:hover {
            color: #0079FF;
            font-weight: bold;
            .right-triangle {
              border-left: 16px solid #0079FF;
            }
          }
          .right-triangle {
            display: inline-block;
            margin-left: 15px;
            padding-top: 2px;
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-left: 18px solid #ddd;
            border-bottom: 8px solid transparent;
          }
          img {
            margin-left: 20px;
            height: 14px;
          }
        }
      }
    }
  }
  .miracle {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0 60px 0;
    .title {
        height: 24px;
        line-height: 24px;
        font-size: 24px;
        font-weight: 400;
        color: #0079FF;
        border-left: 20px solid #0079FF;
        padding-left: 13px;
      }
    .mir-service {
      .service-list {
        display: flex;
        justify-content: space-around;
        padding: 0 40px;
        margin-top: 110px;
        .service-item {
          width: 240px;
          height: 279px;
          background: #FFFFFF;
          text-align: center;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.32);
          border-radius: 8px;
          h3 {
            font-size: 16px;
            font-weight: 800;
            color: #222222;
            margin-top: 70px;
          }
          p {
            width: 196px;
            height: 60px;
            margin: 27px auto 20px auto;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
          }
          button {
            width: 120px;
            height: 40px;
            color: #666666;
            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #999999;
            cursor: pointer;
          }
        }
        .service-item:hover {
          box-shadow: 0px 10px 16px 0px rgba(0, 0, 0, 0.32);
          h3 {
            color: #0079FF;
          }
          button  {
            border: none;
            color: #fff;
            background: #0079FF;
            border-radius: 8px;
          }
        }
      }
    }
    .mir-partner {
      margin-top: 119px;
      width: 1200px;
      margin: 119px auto 0 auto;
      .header-list {
        width: 1154px;
        height: 60px;
        line-height: 60px;
        background: #F1F8FF;
        display: flex;
        justify-content: space-between;
        margin: 73px auto 30px auto;
        div {
          width: 155px;
          text-align: center;
          font-size: 18px;
          font-weight: 600;
          color: #0079FF;
        }
      }
      .first-part {
        width: 1154px;
        margin:0 auto;
        overflow: hidden;
        transition: height 0.5s ease;
      }
      .first-part-open {
        height: 480px;
      }
      .first-part-close {
        height: 160px;
      }
      .second-part {
        width: 1154px;
        margin:0 auto;
        height: 80px;
        overflow: hidden;
        transition: height 0.3s ease;
      }
      .second-part-open {
        height: 160px;
      }
      .second-part-close {
        height: 80px;
      }
      .partner-list {
        display: flex;
        justify-content: space-between;
        div {
          width: 155px;
          height: 80px;
          text-align: center;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            left: 50%;	
            transform: translate(-50%, -50%);
          }
        }
      }
      .open-btn {
        margin-top: 80px;
        text-align: center;
        button {
          width: 140px;
          height: 40px;
          background: #FFFFFF;
          border-radius: 8px;
          border: 1px solid #999999;
          cursor: pointer;
        }
      }
    }
  }
}
</style>>

 